export const whitelabel = {
  plans: 'Plane',
  managePlan: 'Menaxho Planet',
  whitelabelCharges: 'Tarifat e Whitelabel',
  chargesOrTaxesConfiguration: 'Konfigurimi i Tarifave/Taksave',
  websitePlans: 'Plane të faqes',
  whatsappPlansHeader: 'Plane të WhatsApp',
  addOnPlans: {
      createAddOnPlans: 'Krijo Plane Shtesë',
      checkoutYourCurrentMessage: 'Shikoni planet tuaja aktuale shtesë të mesazheve dhe planet e reja për klientët tuaj',
      choosePlanValidity: 'Zgjidhni Vlefshmërinë e Planit',
      chooseValidity: 'Zgjidh Vlefshmërinë',
      oneYear: 'Një Vit',
      billingCycle: 'Cikli i Faturimit',
      numberOfMessages: 'Numri i Mesazheve',
      pleaseEnterNumberOfMessages: 'Ju lutemi vendosni numrin e mesazheve',
      setCurrency: 'Zgjidhni Monedhën',
      select: 'Zgjidhni',
      inr: 'INR',
      usd: 'USD',
      cad: 'CAD',
      clearAll: 'Pastrojini të gjitha',
      apply: 'Aplikoni',
      currency: 'Monedha',
      amount: 'Shuma',
      validity: 'Vlefshmëria',
      upgradePlan: 'Përmirëso Planin',
      addPlan: 'Shto Plan',
      serialNumber: 'Nr. Serik',
      messages: 'Mesazhet',
      // validity: 'Vlefshmëria',
      active: 'Aktive',
      priceDetails: 'Detajet e Çmimit',
      action: 'Veprim',
      addOnChanges: 'Tarifat e Shtesave: ',
      // messages: ' Mesazhet',
      perYear: 'çdo Vit',
      taxes: 'Taksa',
      placeholders: {
          enterNumberOfMesasges: 'Vendosni numrin e mesazheve',
          enterAmount: 'Vendosni Shumën',
          enterValidity: 'Vendosni Vlefshmërinë',
          searchByMessages: 'Kërko sipas Mesazheve'
      },
      modal: {
          deleteAddOnsPlan: 'Fshi Planet e Shtesave',
          wantToDeleteThisAddOnsPlan: 'A jeni të sigurt se dëshironi të fshini këtë Plan të Shtesave?',
      }
  },
  charges: {
      addWhitelabelCharges: 'Shto Tarifat Whitelabel',
      checkoutExistingCharges: 'Shihni tarifat ekzistuese në metoda të ndryshme të pagesës dhe shtoni tarifa të reja whitelabel',
      currency: 'Monedha',
      chooseCurrency: 'Zgjidhni Monedhën',
      amountPerBotPerMonth: 'Shuma për bot çdo muaj',
      cancel: 'Anulo',
      upgradeChanges: 'Përmirëso Tarifat',
      addCharges: 'Shto Tarifat',
      serialNumber: 'Nr. Serik',
      // currency: 'Monedha',
      action: 'Veprim',
      taxes: 'Taksa',
      placeholders: {
          enterAmountBotPerMonth: 'Vendosni shumën për bot çdo muaj',
          searchByCurrency: 'Kërko sipas Monedhës',
      },
      modal: {
          deleteCharges: 'Fshi Tarifat',
          wantToDeleteThisCharge: 'A jeni të sigurt se dëshironi të fshini këtë Tarifë?',
      }
  },
  planManagement: {
      createNewPlans: 'Krijo Plane të Reja',
      checkoutYourCurrentPlan: 'Shihni planet tuaja aktuale dhe shtoni plane të reja për klientët tuaj',
      choosePlan: 'Zgjidhni Planin',
      selectPlan: 'Zgjidhni Planin',
      baby: 'Bebi',
      king: 'Mbreti',
      displayName: 'Emri i Shfaqur',
      messageLimit: 'Kufiri i Mesazheve',
      enterAValidEmail: 'Vendosni një email të vlefshëm',
      setCurrency: 'Zgjidhni Monedhën',
      select: 'Zgjidhni',
      inr: 'INR',
      usd: 'USD',
      cad: 'CAD',
      clearAll: 'Pastrojini të gjitha',
      apply: 'Aplikoni',
      perMonth: '/Muaj',
      perYear: '/Vit',
      cancel: 'Anulo',
      upgradePlan: 'Përmirëso Planin',
      addPlan: 'Shto Plan',
      serialNumber: 'Nr. Serik',
      plan: ' Plan',
      // displayName: 'Emri i Shfaqur',
      messages: 'Mesazhet',
      pricing: 'Çmimet',
      actions: 'Veprimet',
      // plan: ' Plan',
      perMonthText: 'Çdo Muaj',
      perYearText: 'Çdo Vit',
      placeholders: {
          enterDisplayName: 'Vendosni emrin e shfaqur',
          enterMessageLimit: 'Vendosni kufirin e mesazheve',
          searchByPlanName: 'Kërko sipas Emrit të Planit ose Mesazheve',
      },
      modal: {
          deletePlan: 'Fshi Planin',
          wantToDeleteThisBabyPlan: 'Fshirja e Planit të Bebikut do të ketë ndikim në të gjithë Klientët. A jeni të sigurt se dëshironi të fshini këtë plan?',
          wantToDeleteThisPlan: 'A jeni të sigurt se dëshironi të fshini këtë plan?',
      },
      appTooltip: {
          chooseYourPlanType: 'Zgjidhni llojin e planit tuaj',
          pleaseInputYourPlanDisplayName: 'Ju lutemi vendosni emrin e shfaqur të planit tuaj',
          typeMessageLimitForCustomer: 'Shkruani kufirin e mesazheve për klientin',
          selectYourPreferredCurrencies: 'Zgjidhni monedhat tuaja të preferuara',
      }
  },
  taxesConfiguration: {
      addTaxes: 'Shto Taksa',
      checkoutExistingTaxes: 'Shihni taksat ekzistuese në metoda të ndryshme të pagesës dhe taksa të reja',
      taxName: 'Emri i Taksave',
      applicableOn: 'I zbatueshëm në',
      choosePlans: 'Zgjidhni Planet',
      chooseCurrency: 'Zgjidhni Monedhën',
      percentage: 'Përqindja',
      cancel: 'Anulo',
      // addTaxes: 'Shto Taksa',
      serialNumber: 'Nr. Serik',
      name: 'emri',
      // percentage: 'Përqindja',
      currency: 'Monedha',
      updateTaxes: 'Përditëso Taksat',
      actions: 'Veprimet',
      modal: {
          deleteTaxes: 'Fshi Taksa',
          wantToDeleteThisTax: 'A jeni të sigurt se dëshironi të fshini këto taksa?',
      },
      placeholders: {
          taxName: 'Emri i Taksave',
          taxPercentage: 'Përqindja e Taksave',
          searchByCurrency: 'Kërko sipas Monedhës',
      }
  },
  whatsappPlans: {
      createNewPlans: 'Krijo Plane të Reja',
      checkoutYourCurrentAndNewPlans: 'Shihni planet tuaja aktuale dhe shtoni plane të reja për klientët tuaj',
      choosePlan: 'Zgjidhni Planin',
      selectPlan: 'Zgjidhni Planin',
      baby: 'Bebi',
      king: 'Mbreti',
      displayName: 'Emri i Shfaqur',
      messageLimit: 'Kufiri i Bisedës',
      enterAValidMessageLimit: 'Vendosni një kufi të vlefshëm të bisedës',
      setCurrency: 'Zgjidhni Monedhën',
      select: 'Zgjidhni',
      inr: 'INR',
      usd: 'USD',
      cad: 'CAD',
      clearAll: 'Pastrojini të gjitha',
      apply: 'Aplikoni',
      perMonth: '/Muaj',
      perYear: '/Vit',
      cancel: 'Anulo',
      addPlan: 'Shto Plan',
      serialNumber: 'Nr. Serik',
      plan: 'Plan',
      messages: 'Bisedat',
      pricing: 'Çmimet',
      actions: 'Veprimet',
      perMonthText: 'Çdo Muaj',
      perYearText: 'Çdo Vit',
      updatePlan: 'Përmirëso Planin',
      // addPlan: 'Shto Plan',
      placeholders: {
          enterDisplayName: 'Vendosni emrin e shfaqur',
          enterMessageLimit: 'Vendosni kufirin e bisedës',
          searchByPlanName: 'Kërko sipas Emrit të Planit ose Bisedave',
      },
      appTooltip: {
          typeMessageLimitForCustomer: 'Shkruani kufirin e bisedës për klientin',
          chooseYourPlanType: 'Zgjidhni llojin e planit tuaj',
          selectYourPreferredCurrencies: 'Zgjidhni monedhat tuaja të preferuara',
          pleaseInputYourPlanDisplayName: 'Ju lutemi vendosni emrin e shfaqur të planit tuaj',
      },
      modal: {
          deletePlan: 'Fshi Planin',
          areYouSureYouWantToDeleteThisPlan: 'A jeni të sigurt se dëshironi të fshini këtë plan?',
          wantToDeleteThisBabyPlan: 'Fshirja e Planit të Bebikut do të ketë ndikim në të gjithë Klientët. A jeni të sigurt se dëshironi të fshini këtë plan?',
      }
  }
};
